import {Component, OnDestroy, Renderer2} from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent implements OnDestroy {

  constructor(private readonly renderer: Renderer2) {
    this.renderer.addClass(document.body, 'exception-body');
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'exception-body');
  }
}
